import { render, staticRenderFns } from "./CancelledData.vue?vue&type=template&id=162387a6&"
import script from "./CancelledData.vue?vue&type=script&lang=js&"
export * from "./CancelledData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162387a6')) {
      api.createRecord('162387a6', component.options)
    } else {
      api.reload('162387a6', component.options)
    }
    module.hot.accept("./CancelledData.vue?vue&type=template&id=162387a6&", function () {
      api.rerender('162387a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-order/components/CancelledData.vue"
export default component.exports